// extracted by mini-css-extract-plugin
export default {"flex":"flex-JFHUw","menuWrapper":"menuWrapper-ovZ3x","relative":"relative-iP1Oh","menu":"menu-Zhp10","subMenu":"subMenu-isPeZ"};